import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Component to render drawing pages grouped by type in a collapsible tree view.
 * Props:
 *  - grouped: object mapping drawingType to array of pages
 *  - onSelect: function(pageId) called when a page is clicked
 */
const DrawingTreeView = ({ grouped, onSelect, onEdit, onCategoryChange }) => {
  const entries = Object.entries(grouped || {});
  if (entries.length === 0) {
    return <p className="text-gray-500">No drawings to display.</p>;
  }
  return (
    <div>
      {entries.map(([type, pages]) => (
        <details key={type} className="mb-4" open>
          <summary className="cursor-pointer font-semibold bg-gray-200 p-2 rounded">
            {type} ({pages.length})
          </summary>
          <ul className="mt-2">
            {pages.map(page => (
              <li
                key={page.id}
                className="flex items-center justify-between p-2 hover:bg-gray-100 rounded cursor-pointer transition-colors"
                onClick={() => onSelect(page.id)}
                onContextMenu={e => {
                  e.preventDefault();
                  onEdit && onEdit(page);
                }}
                title="Right-click to edit metadata"
              >
                <div className="flex flex-col">
                  <span className="font-medium">
                    {page.drawingNumber ? `${page.drawingNumber} - ` : ''}
                    {page.title}
                  </span>
                  {page.revDate && (
                    <span className="text-sm text-gray-500">
                      Rev: {page.revDate}
                    </span>
                  )}
                </div>
                {page.needsReview && <AlertTriangle className="text-red-500" size={16} />}
                {/* Category dropdown */}
                {onCategoryChange && (
                  <select
                    value={page.drawingType}
                    onChange={e => onCategoryChange(page.id, e.target.value)}
                    className="ml-4 p-1 border rounded text-sm"
                  >
                    {[
                      'Architectural',
                      'Structural Steel',
                      'Mechanical',
                      'Electrical',
                      'Civil',
                      'Landscape',
                      'Miscellaneous'
                    ].map(type => (
                      <option key={type} value={type}>{type}</option>
                    ))}
                  </select>
                )}
              </li>
            ))}
          </ul>
        </details>
      ))}
    </div>
  );
};

export default DrawingTreeView;